import { TimerPlayOutlineIcon } from './TimerPlayOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 0E6F9270-1D27-4E36-9352-0BACC428A548
 * name timer-play-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-play-outline.svg
 * tags
 * - Date / Time 
 */
export const TimerStartOutlineIcon = TimerPlayOutlineIcon;
export default TimerStartOutlineIcon